module.exports = __webpack_public_path__ + "img/icon-png.2e41f139.svg";